export default __webpack_public_path__ + "c514b783a4e6831bf209f9ed81813621.wav";